import { Card } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

export default function HistoryCounter({ counts, label = "Terminados" }) {
  return (
    <Card className="p-4 border-zinc-200 rounded-md bg-gradient-to-r from-zinc-50 to-white">
      <div className="flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-emerald-600" />
          <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">{label}</span>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <div>
            <span className="font-manrope font-black text-2xl leading-none text-emerald-700">{counts.hoy}</span>
            <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold ml-1.5">Hoy</span>
          </div>
          <span className="text-zinc-300">·</span>
          <div>
            <span className="font-manrope font-black text-2xl leading-none text-zinc-700">{counts.ayer}</span>
            <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold ml-1.5">Ayer</span>
          </div>
          <span className="text-zinc-300">·</span>
          <div>
            <span className="font-manrope font-black text-2xl leading-none text-zinc-400">{counts.total}</span>
            <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold ml-1.5">Total historial</span>
          </div>
        </div>
      </div>
    </Card>
  );
}
